export enum TKickoffEvents {
  BACK = 'BACK',
  BACK_TO_IDEL = 'BACK_TO_IDEL',
  REGULAR_KICK = 'REGULAR_KICK',
  ONSIDE_KICK = 'ONSIDE_KICK',
  REF_EVENT = 'REF_EVENT',
  PENALTY = 'PENALTY',
  KICK_RESULT = 'KICK_RESULT',
  KICKOFF_COMPLETED = 'KICKOFF_COMPLETED',
  TO_IDEL = 'TO_IDEL',
  TO_COIN_TOSS_SELECT_SIDE = 'TO_COIN_TOSS_SELECT_SIDE',
  BACK_TO_KICKOFF_START = 'BACK_TO_KICKOFF_START',
  POSSESSION_SELECTED = 'POSSESSION_SELECTED',
  BACK_TO_SELECT_POSSESSION = 'BACK_TO_SELECT_POSSESSION',
}

export enum TKickoffStates {
  START_KICKOFF = 'START_KICKOFF',
  KICKOFF_KICKED = 'KICKOFF_KICKED',
  KICKOFF_RESULT = 'KICKOFF_RESULT',
  SELECT_YARDAGE = 'SELECT_YARDAGE',
  REF_EVENT = 'REF_EVENT',
  SELECT_REF_TYPE = 'SELECT_REF_TYPE',
  HANDLE_YARDAGE_TOGGLES = 'HANDLE_YARDAGE_TOGGLES',
  KICKOFF_CONFIRMATION = 'KICKOFF_CONFIRMATION',
  SELECT_POSSESSION = 'SELECT_POSSESSION',
}
